<template>
  <div class="page2_wrapper">
    <SwiperList :swiperList="swiperList"></SwiperList>
    <div class="container">
      <div class="main">
        <div class="left" v-if="navs">
          <div class="first_menuname">-- {{ parentActiveTab.label }} --</div>
          <div class="page2_left_nav">
            <Nav
              :currentTab="childActiveTab.index"
              :navs="navs"
              @change="navChange"
            ></Nav>
          </div>
        </div>
        <div class="right">
          <div class="breadcrumb">
            <div class="lable">当前位置:</div>
            <div class="breadcrumb_item">
              <div @click="returnPre(0)">首页</div>
              <div @click="returnPre(1)">
                <span>></span>{{ parentActiveTab.label }}
              </div>
              <div @click="returnPre(2)">
                <span>></span>{{ childActiveTab.label }}
              </div>
              <div v-if="childActiveTab.last">
                <div class="breadcrumb_item_title">
                  <span>></span><span>{{ childActiveTab.last.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <!--showtype=1 折叠式-->
          <div v-if="childActiveTab.showtype === '1'" class="simplelist">
            <div class="simple_item" v-for="(item, index) in list" :key="index">
              <div class="text" @click="open(index)">
                <div class="icon_jiao"></div>
                <div class="icon"><span>Q</span></div>
                <div class="title">{{ item.name }}</div>
                <div class="jiantou"></div>
              </div>
              <div v-if="activeIndex === index" class="simple_box">
                <div
                  class="simple_content pre_content"
                  v-html="item.content"
                ></div>
                <!--{{item.content}}-->
              </div>
            </div>
          </div>
          <!--showtype=2 内容列表\showtype=4文件下载-->
          <div
            v-if="
              (childActiveTab.showtype === '2' ||
                childActiveTab.showtype === '4') &&
              !childActiveTab.last
            "
            class="list"
          >
            <div class="list main_list_table_th page2_list_table_th">
              <div class="main_list_table">
                <el-table
                  :show-header="true"
                  highlight-current-row
                  @current-change="handleCurrentChange"
                  :data="list"
                  style="width: 100%"
                >
                  <!--<el-table-column prop="name" label="标题"></el-table-column>-->
                  <el-table-column
                    prop="name"
                    :label="
                      childActiveTab.showtype === '2' ? '标题' : '文档名称'
                    "
                  >
                    <template slot-scope="scope">
                      <span class="icon" v-if="childActiveTab.showtype === '2'"
                        ><i class="el-icon-reading"></i></span
                      >{{ scope.row.name }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="200"
                    v-if="childActiveTab.showtype === '2'"
                    prop="publishtime"
                    label="发布时间"
                  >
                    <template slot-scope="scope">
                      <div style="display: flex; justify-content: center">
                        {{ scope.row.publishtime }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    v-if="childActiveTab.showtype === '4'"
                    width="200px"
                  >
                    <template slot-scope="scope">
                      <div style="display: flex; justify-content: center">
                        <div
                          class="list_btn"
                          v-if="scope.row.url"
                          :class="{ active: activeTab === 1 }"
                          @click.stop="downFile(scope.row.url)"
                        >
                          <div class="button">下载</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="page">
                <page
                  @pageChanged="pageChanged"
                  :total="total"
                  :currentPage="query.currentPage"
                  :pageSize="pageSize"
                ></page>
              </div>
            </div>
          </div>
          <div v-if="childActiveTab.showtype === '2' && last" class="content">
            <div class="pre_content" v-html="childActiveTab.last.content"></div>
            <div style="display: flex; justify-content: center">
              <span>附件下载</span>
              {{  childActiveTab.last.filename }}
              <div class="name" @click="downFile(item.appendurl)"></div>
            </div>
          </div>
          <!--showtype=3 文本-->
          <div v-if="childActiveTab.showtype === '3'" class="content">
            <div
              class="pre_content"
              v-if="list.length"
              v-html="list[0].content"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Nav from "./common/Nav";
import SwiperList from "./common/SwiperList";
import Page from "./common/Page";
import _ from "lodash";
import request from "@/utils/request";
import common from "@/mixin/common";
export default {
  name: "Left",
  mixins: [common],
  components: { Nav, SwiperList, Page },
  data() {
    return {
      activeTab: "",
      swiperList: [],
      navs: [],
      total: 0,
      pageSize: 7,
      query: {
        currentPage: 1,
        offset: 0,
      },
      list: [],
      activeIndex: "",
      debouncedGetAnswer: "",
      last: "",
    };
  },
  created() {
    this.navs = this.parentActiveTab.children;
    this.getPage2List();
    this.getSwiperList();
    if (this.childActiveTab.last) {
      this.last = this.childActiveTab.last;
      this.activeIndex = this.childActiveTab.last.index;
    }
  },
  watch: {
    async $route() {
      this.navs = this.parentActiveTab.children;
      await this.getPage2List();
      await this.getSwiperList();
    },
    childActiveTab() {
      this.list = [];
      this.getPage2List();
    },
  },
  methods: {
    download(item) {
      var tempwindow = window.open("_blank");
      /* eslint-disable*/
      let url = window.URL.createObjectURL(
        new Blob(["\uFEFF" + this.picAddr + item.url])
      );
      // console.log(url)
      tempwindow.location = this.picAddr + item.url;
    },
    open(index) {
      if (this.activeIndex === index) {
        this.activeIndex = "";
      } else {
        this.activeIndex = index;
      }
    },
    async getSwiperList() {
      let res = await request({
        method: "get",
        url: "/web/web/getCarfigList",
        params: {
          carfigwmenuid: this.parentActiveTab.value,
          cosid: this.cosId,
        },
      });
      this.swiperList = res;
    },
    getDebounceList: _.debounce(function () {
      this.getPage2List();
    }, 300),
    returnPre(val) {
      // 返回首页
      if (val === 0) {
        this.$router.replace({ path: "/" });
        // this.$store.commit('changeState', {'parentActiveTab': ''})
        // this.$store.commit('changeState', {'childActiveTab': ''})
      } else if (val === 1) {
        this.childActiveTab.last = "";
        this.last = "";
        this.$store.commit("changeState", { childActiveTab: this.navs[0] });
      } else if (val === 2) {
        this.childActiveTab.last = "";
        this.last = "";
        this.$store.commit("changeState", {
          childActiveTab: this.childActiveTab,
        });
      }
    },
    handleCurrentChange(val) {
      if (this.childActiveTab.showtype !== "4") {
        let obj = this.childActiveTab;
        obj.last = val;
        this.last = val;
        this.$store.commit("changeState", { childActiveTab: obj });
      }
    },
    navChange(value, obj) {
      obj.last = "";
      this.last = "";
      this.$store.commit("changeState", { childActiveTab: obj });
      // console.log(value, obj, '二级菜单点击', this.childActiveTab)
      this.query.currentPage = 1;
      // this.getDebounceList()
    },
    async getPage2List() {
      // todoo
      this.query.limit = this.query.limit ? this.query.limit : this.pageSize;
      this.query.cosid = this.cosId;
      this.query.wmenuid = this.childActiveTab
        ? this.childActiveTab.value
        : null;
      this.loading = true;
      if (this.query.wmenuid) {
        let res = await request({
          method: "get",
          url: "/web/web/getNoticePageList",
          params: this.query,
        });
        this.list = res.list;
        this.total = res.count[0].count;
      }
      this.loading = false;
    },
    async pageChanged(val) {
      this.query.currentPage = val.currentPage;
      this.query.limit = val.limit;
      this.query.offset = val.offset;
      await this.getPage2List()
    },
  },
  computed: {
    ...mapGetters(["parentActiveTab", "childActiveTab", "cosId"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
@import "../styles//table.scss";

@media screen and (min-width: 1201px) {
  .page2_wrapper {
    .container {
      padding: 40px 0;
      display: flex;
      justify-content: center;
      .main {
        width: 1201px;
        display: flex;
        justify-content: center;
        .left {
          background-color: $color-bg-white;
          width: 220px;
          padding: 20px;
          .first_menuname {
            font-weight: bold;
            font-size: $fontsize-large;
            background-color: $color-orange;
            color: #fff;
            padding: 10px 35px;
          }
        }
        .right {
          flex: 1;
          background-color: $color-bg-white;
          margin-left: 15px;
          .breadcrumb {
            padding: 25px 0 10px;
            margin: 0 20px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #fafafa;
            .lable {
              padding-right: 10px;
              color: $color-text-secondary-gray;
            }
            .breadcrumb_item {
              display: flex;
              justify-items: center;
              cursor: pointer;
              :last-child {
                color: $color-text-secondary-gray;
                cursor: text;
              }
              span {
                margin: 0 5px;
              }
              .breadcrumb_item_title {
                width: 380px;
                list-style: none;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }
          .content {
            padding: 15px 20px;
            line-height: 28px;
          }
          .list {
            padding: 10px;
            .icon {
              padding-right: 10px;
            }
            .page {
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: $color-bg-white;
              padding: 18px 0;
            }
            .list_btn {
              font-size: $fontsize-medium;
              cursor: pointer;
              color: $color-orange;
              display: flex;
              .button {
                padding: 1px 18px;
                border: 1px solid $color-orange;
              }
            }
            .being {
              .button {
                background-color: $color-being-green;
              }
            }
          }
          .simplelist {
            color: $color-dark-gray;
            padding-top: 18px;
            padding-bottom: 50px;
            .simple_item {
              padding: 23px 0 0;
              .text {
                padding-left: 14px;
                padding-right: 23px;
                display: flex;
                /*justify-content: space-between;*/
                align-items: center;
                cursor: pointer;
                .icon_jiao {
                  position: relative;
                  left: 22px;
                  top: 13px;
                  width: 0;
                  height: 0;
                  background-color: transparent;
                  border-right: 8px solid transparent;
                  border-left: 0px solid transparent;
                  border-top: 5px solid $color-orange;
                }
                .icon {
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  color: #fff;
                  align-items: center;
                  width: 36px;
                  height: 22px;
                  background-color: $color-orange;
                }
                .title {
                  padding-left: 20px;
                  font-size: $fontsize-large-x;
                  flex: 1;
                }
                .jiantou {
                  cursor: pointer;
                  margin-left: 24px;
                  width: 15px;
                  height: 10px;
                  background-size: 15px 10px;
                  background-image: url("../assets/img/icon_xiajiantou.png");
                }
              }
              .simple_box {
                margin: 23px 22px 0;
                padding-top: 0;
                background-color: $color-bg-gray;
                flex-wrap: wrap;
                .simple_content {
                  line-height: 22px;
                  padding: 12px;
                  width: 920px;
                  word-break: break-all;
                  word-wrap: break-word;
                  overflow-y: auto;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .container {
    .main {
      .left {
        width: 100%;
        .first_menuname {
          text-align: center;
          font-weight: bolder;
          background-color: $color-orange;
          margin: 10px 50px;
          padding: 10px 10px;
          color: #fff;
        }
        .page2_left_nav {
          padding: 10px 10px;
          -moz-box-shadow: 1px 1px 7px #9c9c9c;
          -webkit-box-shadow: 1px 1px 7px #9c9c9c;
          box-shadow: 1px 1px 7px #9c9c9c;
        }
      }
      .right {
        margin: 30px 0;
        .breadcrumb {
          display: flex;
          margin: 10px;
          .breadcrumb_item {
            display: flex;
          }
        }
      }
    }
  }
}
</style>
